import * as React from 'react';
import Button, { ButtonContext, ButtonType } from './Button';

const sectionStyle: React.CSSProperties = { marginBottom: '40px' };
const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexWrap: 'wrap',
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <section style={sectionStyle}>
    <h2>{title}</h2>
    <div style={rowStyle}>{children}</div>
  </section>
);

const CONTEXTS: ButtonContext[] = ['talent', 'company', 'neutral', 'semantic'];
const TYPES: ButtonType[] = ['primary', 'secondary', 'terceary'];

const ButtonExamples: React.FC = () => {
  const handleClick = () => alert('Button clicked');

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Button Component Examples</h1>

      <Section title="All combinations (context × type)">
        {CONTEXTS.map((context) =>
          TYPES.map((type) => (
            <Button key={`${context}-${type}`} context={context} type={type} onClick={handleClick}>
              {context} / {type}
            </Button>
          ))
        )}
      </Section>

      <Section title="Sizes">
        <Button size="S" onClick={handleClick}>Small</Button>
        <Button size="M" onClick={handleClick}>Medium</Button>
      </Section>

      <Section title="Icons (color and size are derived from context + type; icon is always rendered at sm)">
        <Button iconLeft="file" context="talent" onClick={handleClick}>
          File
        </Button>
        <Button iconRight="arrowRight" context="talent" type="secondary" onClick={handleClick}>
          Continue
        </Button>
        <Button iconLeft="arrowLeft" context="talent" type="terceary" onClick={handleClick}>
          Back
        </Button>
        <Button iconLeft="user" iconRight="image" context="company" onClick={handleClick}>
          Profile
        </Button>
      </Section>

      <Section title="Disabled by type">
        <Button disabled onClick={handleClick}>Primary</Button>
        <Button disabled type="secondary" onClick={handleClick}>Secondary</Button>
        <Button disabled type="terceary" onClick={handleClick}>Terceary</Button>
        <Button disabled iconLeft="user" iconRight="image" context="company" onClick={handleClick}>
          With icons
        </Button>
      </Section>

      <Section title="As links">
        <Button href="/profile">Go to Profile</Button>
        <Button href="/jobs" type="secondary">Browse Jobs</Button>
        <Button href="https://example.com" target="_blank" iconRight="link">
          External
        </Button>
        <Button href="/disabled" disabled>Disabled link</Button>
      </Section>

      <Section title="Real-world">
        <Button context="talent" type="primary" onClick={handleClick}>
          Apply Now
        </Button>
        <Button context="company" type="secondary" href="/dashboard">
          Dashboard
        </Button>
        <Button iconLeft="arrowLeft" onClick={handleClick}>
          Go Back
        </Button>
      </Section>
    </div>
  );
};

export default ButtonExamples;
